import { Post, postJSON } from "../utils/http.js"

// 添加商品到购物车
export function addToCartV2(params, shipmentType = null) {
  return Post(
    "/api/cart/v20/addToCart",
    params,
    {
      loading: true
    },
    shipmentType
  )
}

// 获取购物车详情
export function getCartDetailV2(params, shipmentType = null) {
  return Post(
    "/api/cart/v20/cartInfo",
    params,
    {
      loading: false
    },
    shipmentType
  )
}

// 修改商品数量
export function modifyCartV2(params, shipmentType = null) {
  return Post(
    "/api/cart/v20/updateCartItem",
    params,
    {
      loading: true
    },
    shipmentType
  )
}
// 获取配送信息
export function getConsignInfo(params) {
  return Post("/api/order/consign/modify", params, {
    loading: true
  })
}

// 获取优惠券信息
export function getCouponBillV2(params, config = { loading: true }) {
  return postJSON("/api/order/couponBill/v2", params, config)
}
